/**
 * Product catalog – đồng bộ với hệ thống EPOS (DOCS/EPOS/screenshots/01_lua_chon_san_pham)
 * Mỗi sản phẩm có 4 icon mục tiêu tài chính (life-protection, education, retirement, savings)
 */

export type ProductTarget = 'life-protection' | 'education' | 'retirement' | 'savings';
export type ProductType = 'linked-unit' | 'linked-general';

export interface Product {
  id: string;
  name: string;
  fullName: string;
  type: ProductType;
  typeLabel: string;
  tagline: string;
  targets: ProductTarget[];
  features: string[];
  requireRiskAssessment: boolean;
  isDefault?: boolean;
}

export const PRODUCTS: Product[] = [
  {
    id: 'XUM',
    name: 'Xanh Ước Mơ',
    fullName: 'Sản phẩm Bảo hiểm Liên kết chung Xanh Ước Mơ',
    type: 'linked-general',
    typeLabel: 'Liên kết chung',
    tagline: 'Giải pháp tích lũy giáo dục 1 2 3',
    targets: ['life-protection', 'education', 'retirement', 'savings'],
    features: [
      'Bảo vệ trọn đời trước các rủi ro trong cuộc sống',
      'Tích luỹ hiệu quả với lãi suất cam kết và lãi suất gia tăng',
      'Thưởng duy trì hợp đồng tại cột mốc kỷ niệm năm thứ 10',
      'Gia tăng STBH khi có thành viên mới trong gia đình',
    ],
    requireRiskAssessment: false,
    isDefault: true,
  },
  {
    id: 'XPQ',
    name: 'Xanh Phú Quý',
    fullName: 'Sản phẩm Bảo hiểm Liên kết đơn vị Xanh Phú Quý',
    type: 'linked-unit',
    typeLabel: 'Liên kết đơn vị',
    tagline: 'Kiến Tạo Gia Sản',
    targets: ['life-protection', 'education', 'retirement', 'savings'],
    features: [],
    requireRiskAssessment: true,
  },
  {
    id: 'XTL-PS',
    name: 'Xanh Tương Lai',
    fullName: 'Sản phẩm Bảo hiểm Liên kết đơn vị Xanh Tương Lai (Phiên bản phí ổn định)',
    type: 'linked-unit',
    typeLabel: 'Liên kết đơn vị',
    tagline: 'Giải pháp Tài Chính Đa Mục Tiêu',
    targets: ['life-protection', 'education', 'retirement', 'savings'],
    features: [
      'An tâm hoạch định với tổng phí bảo hiểm ổn định hàng năm',
      'Bảo vệ tối ưu với quyền lợi gia tăng STBH lên đến 175% STBH ban đầu',
      'Xây dựng quỹ tài chính cho tương lai hưng thịnh với 9 Quỹ liên kết đơn vị',
    ],
    requireRiskAssessment: true,
  },
  {
    id: 'XTL',
    name: 'Xanh Tương Lai',
    fullName: 'Sản phẩm Bảo hiểm Liên kết đơn vị Xanh Tương Lai',
    type: 'linked-unit',
    typeLabel: 'Liên kết đơn vị',
    tagline: 'Giải pháp tài chính đa mục tiêu 3 Cộng (+)',
    targets: ['life-protection', 'education', 'retirement', 'savings'],
    features: [
      'Bình an trọn vẹn trước các rủi ro về sinh mạng và sức khỏe',
      'Tự động gia tăng STBH từ Năm Hợp Đồng 02 đến 06',
      'Gia tăng STBH khi có thành viên mới trong gia đình',
      'Xây dựng tương lai hưng thịnh với danh mục quỹ liên kết đơn vị ưu việt',
    ],
    requireRiskAssessment: true,
  },
];

export const findProductById = (id: string): Product | undefined =>
  PRODUCTS.find((p) => p.id === id);
